import { z } from 'zod';
import { fleetRecoverySha256Schema, fleetRecoveryUuidSchema } from '../fleetRecoverySchemas';
import { recoveryQuiescenceProofV3Schema } from './auxiliary';
import { recoveryReceiptV3Schema } from './observations';

/** The API derives device, correlation and release identity from its exact issued capsule. */
export const recoveryCapsuleReceiptV1Schema = recoveryReceiptV3Schema.omit({ schemaVersion: true, deviceId: true,
  correlationId: true, releaseEnvelopeSha256: true }).extend({ capsuleSha256: fleetRecoverySha256Schema,
  operationId: fleetRecoveryUuidSchema, quiescence: recoveryQuiescenceProofV3Schema.nullable() }).strict();
export type RecoveryCapsuleReceiptV1 = z.infer<typeof recoveryCapsuleReceiptV1Schema>;
